module.exports = __webpack_public_path__ + "a17d279f/img/at-icon.5d6fc5d8.svg";